import { formatGeospatialLink } from 'features/kestrelViewer'
import { useMemo } from 'react'
import {
  KestrelInspectionType,
  KVAnnotation,
  KVCoordinate,
  WorldPosition,
} from 'types'

interface KestrelModelData {
  inspection_type?: KestrelInspectionType
  origin?: {
    lat: number
    long: number
    elevation: number
  }
  measurementScale?: number
}

interface KestrelModel {
  data: KestrelModelData
}

export const useAnnotationGeospatialLink = (
  kestrelModel: KestrelModel | null | undefined,
  annotation: KVAnnotation,
  enabled: boolean
): string | null => {
  return useMemo(() => {
    const hasOrigin = !!kestrelModel?.data.origin
    if (!enabled || !hasOrigin) {
      return null
    }

    try {
      const originData = kestrelModel.data.origin

      if (!originData) return null

      const origin = new KVCoordinate(
        originData.lat,
        originData.long,
        originData.elevation
      )

      let centerCoords: WorldPosition

      if (annotation.centeredPosition) {
        centerCoords = annotation.centeredPosition as WorldPosition
      } else if (
        annotation.geometry?.kind === 'point' &&
        annotation.geometry.position
      ) {
        centerCoords = annotation.geometry.position as WorldPosition
      } else {
        console.warn('No position data found for annotation')
        return null
      }

      const measurementScale = (kestrelModel.data.measurementScale ?? 100) / 100

      const geoCoord = KVCoordinate.fromWorldCoordinate(
        centerCoords,
        origin,
        measurementScale
      )

      return formatGeospatialLink({
        lat: geoCoord.lat,
        lng: geoCoord.long,
        elevation: geoCoord.elevation,
      })
    } catch (error) {
      console.error('Failed to calculate geospatial coordinates:', error)
      return null
    }
  }, [kestrelModel, annotation, enabled])
}
